import { v4 as uuidv4 } from 'uuid';

export function GUID(): string {
	const guid = uuidv4();
	return guid;
}

export const Guid_Empty = '00000000-0000-0000-0000-000000000000';